import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { TextField } from "react-md";
import { MSelect } from "components/Shared";
import { allCountiesFromBoundaries } from "selectors/menuItems";

const RequestCoverageOption = props => {
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCounty, setSelectedCounty] = useState(null);
  const [filteredCounties, setFilteredCounties] = useState([]);
  const volume = useRef(null);

  const onStateSelected = option => {
    if (option) {
      setSelectedState(option);
      setFilteredCounties(props.allCountyOptions.filter(c => c.state === option.value));
    } else {
      setSelectedState(null);
      setFilteredCounties([]);
    }
  };

  const onCountySelected = option => {
    setSelectedCounty(option);
    props.onCountyChange(option, props.optionIndex);
  };

  const onVolumeChanged = value => {
    volume.current = value;
    props.onVolumeChange(value);
  };

  return (
    <div className={"request-coverage-flex"} key={props.optionIndex} >
      <MSelect
        className={"request-coverage-state-selection"}
        options={props.stateList?.map(s => ({ label: s.stateName, value: s.stateAbbreviation }))}
        isClearable={true}
        onChange={onStateSelected}
        value={selectedState}
        enablePortal
        getMenuPortalTarget={() => document.querySelector(props.portalTargetClassName)}
      />
      <MSelect
        className={"request-coverage-county-selection"}
        options={filteredCounties}
        isClearable={true}
        onChange={onCountySelected}
        value={selectedCounty}
        enablePortal
        getMenuPortalTarget={() => document.querySelector(props.portalTargetClassName)}
      />
      <TextField
        id={"request-coverage-volume"}
        rows={1}
        type={"number"}
        fullWidth={false}
        resize={{ min: 100, max: 100 }}
        onChange={onVolumeChanged}
      />
    </div>
  );
};

RequestCoverageOption.propTypes = {
  optionIndex: PropTypes.number,
  onCountyChange: PropTypes.func,
  onVolumeChange: PropTypes.func,
  portalTargetClassName: PropTypes.string,  // Container element class name for portal
  // Redux
  stateList: PropTypes.array,
  allCountyOptions: PropTypes.array,
};

const mapStateToProps = state => ({
  allCountyOptions: allCountiesFromBoundaries(state),
  stateList: state.appraiser.stateList,
});

export default connect(mapStateToProps)(RequestCoverageOption);